/**
 * Country -> preferred reporting currency for the *display* layer.
 * Onboarding still lets the user pick any ISO-4217 code — this is just
 * the friendly default at first paint.
 */
const COUNTRY_TO_CURRENCY: Record<string, string> = {
  JP: 'JPY',
  KR: 'KRW',
  CN: 'CNY', TW: 'TWD', HK: 'HKD', SG: 'SGD',
  US: 'USD', CA: 'CAD', MX: 'MXN',
  GB: 'GBP',
  DE: 'EUR', FR: 'EUR', ES: 'EUR', IT: 'EUR', NL: 'EUR', BE: 'EUR',
  AT: 'EUR', IE: 'EUR', PT: 'EUR', FI: 'EUR', LU: 'EUR',
  AU: 'AUD', NZ: 'NZD',
  IN: 'INR', PH: 'PHP', ID: 'IDR', VN: 'VND', TH: 'THB', MY: 'MYR',
  BR: 'BRL', AR: 'ARS', CL: 'CLP', CO: 'COP', PE: 'PEN',
  CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', CZ: 'CZK',
  AE: 'AED', SA: 'SAR', IL: 'ILS', TR: 'TRY', RU: 'RUB',
  ZA: 'ZAR', EG: 'EGP', NG: 'NGN', KE: 'KES',
};

export function currencyForCountry(country?: string | null): string {
  if (!country) return 'USD';
  return COUNTRY_TO_CURRENCY[country.trim().toUpperCase()] ?? 'USD';
}
